import {Action} from '@ngrx/store';
import {Tile, TileId} from '../../shared/models/tile';
import {AppId} from '../../shared/models/app';

export const TILE_LOADED = '[Tiles] loaded single tile';
export const TILES_LOADED = '[Tiles] loaded multiple tiles';
export const TILES_FOR_USER_LOADED = '[Tiles] loaded all tiles for user';
export const TILES_FOR_APP_LOADED = '[Tiles] loaded all tiles in app';
export const TILES_TILE_SAVED = '[Tiles] tile saved to API';
export const TILES_TILE_DELETED = '[Tiles] tile deleted from API';
export const TILE_UNLINKED_FROM_APPS = '[Tiles] tile unlinked from apps';
export const TILE_LINKED_TO_APPS = '[Tiles] tile linked to apps';

export class TileLoaded implements Action {
  readonly type = TILE_LOADED;

  constructor(public tile: Tile) {
  }
}

export class TilesLoadedAction implements Action {
  readonly type = TILES_LOADED;

  constructor(public tiles: Tile[]) {
  }
}

export class TilesForUserLoadedAction implements Action {
  readonly type = TILES_FOR_USER_LOADED;

  constructor(public tiles: Tile[]) {
  }
}

export class TilesForAppLoadedAction implements Action {
  readonly type = TILES_FOR_APP_LOADED;

  constructor(public tiles: Tile[], public appId: AppId) {
  }
}

export class TilesTileSavedAction implements Action {
  readonly type = TILES_TILE_SAVED;

  constructor(public tile: Tile) {
  }
}

export class TilesTileDeletedAction implements Action {
  readonly type = TILES_TILE_DELETED;

  constructor(public tileId: TileId) {
  }
}

export class TileUnlinkedFromAppsAction implements Action {
  readonly type = TILE_UNLINKED_FROM_APPS;

  constructor(public tileId: TileId, public appIds: AppId[]) {
  }
}

export class TileLinkedToAppsAction implements Action {
  readonly type = TILE_LINKED_TO_APPS;

  constructor(public tileId: TileId, public appIds: AppId[]) {
  }
}

export type Actions = TileLoaded
  | TilesLoadedAction
  | TilesForUserLoadedAction
  | TilesForAppLoadedAction
  | TilesTileSavedAction
  | TilesTileDeletedAction
  | TileUnlinkedFromAppsAction
  | TileLinkedToAppsAction;
